import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface LookupOption { id: number; name: string }
export interface Lookups { regions: LookupOption[]; states: Array<LookupOption & { regionId: number | null }> }

export const lookupsApi = {
  async all(): Promise<Lookups> {
    return (await apiClient.get<ApiSuccess<Lookups>>('/lookups')).data.data;
  },
};
